import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { ownDevicesQuerySchema } from "./device-read";

const resourceId = ownDevicesQuerySchema.shape.cursor.unwrap();
export const ownRecordingSessionsQuerySchema = ownDevicesQuerySchema.extend({
  deviceId: resourceId,
});
export type OwnRecordingSessionsQuery = z.output<
  typeof ownRecordingSessionsQuerySchema
>;
export const ownRecordingSessionsSchema = z.object({
  items: z.array(
    z.object({
      id: resourceId,
      deviceId: resourceId,
      status: z.literal("waiting"),
      createdAt: z.iso.datetime(),
    }),
  ),
  nextCursor: resourceId.nullable(),
});
export const recordingSessionReadContract = {
  waitingRecordingSessions: oc
    .errors({
      BAD_REQUEST: { message: "Invalid request" },
      NOT_FOUND: { message: "Not Found" },
      METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
      INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
    })
    .input(
      z.object({
        query: ownRecordingSessionsQuerySchema,
        body: z.undefined().optional(),
      }),
    )
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/recording-sessions",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(ownRecordingSessionsSchema),
};
